export default function Spinner({ size = 'md' }) {
  const dim = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-8 w-8' : 'h-5 w-5';
  return (
    <span
      className={`inline-block ${dim} border-2 border-slate-500 border-t-accent rounded-full animate-spin`}
      aria-label="Cargando"
    />
  );
}
